import React, { useState, useEffect } from 'react';
import '../styles/pay_modal.css';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../config';

import postPayment from '../api/post/postPayment';

const BuyModal = ({ isOpen, bookId, onClose }) => {
    const [bookData, setBookData] = useState(null);
    const [paymentResponse, setPaymentResponse] = useState('');
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

    useEffect(() => {
        const fetchBookData = async () => {
            if (!bookId) return;
            try {
                const bookRef = doc(db, 'books', bookId);
                const bookSnap = await getDoc(bookRef);
                if (bookSnap.exists()) {
                    setBookData(bookSnap.data());
                } else {
                    console.error('Кітап табылмады.');
                }
            } catch (error) {
                console.error('Кітап деректерін жүктеу қатесі:', error);
            }
        };
        fetchBookData();
    }, [bookId]);

    const handleBuyByCard = async (e) => {
        e.preventDefault();
        setPaymentResponse('');

        if (!bookData) {
            alert('Кітап деректері жүктелмеген.');
            return;
        }

        try {
            const user = auth.currentUser;
            if (!user) {
                throw new Error('Пайдаланушы анықталмады.');
            }

            const response = await postPayment(bookId, bookData.price);
            setPaymentResponse(response.response);
            setIsPaymentModalOpen(true);
        } catch (error) {
            console.error('Error processing payment:', error);
            alert('Төлем өңдеу кезінде қате пайда болды. Қайта байқап көріңіз.');
        }
    };

    if (!isOpen || !bookData) return null;

    return (
        <div className="fixed inset-0 z-[102] bg-black/70 backdrop-blur-sm flex items-center justify-center px-4">
            <div className="bg-zinc-900 rounded-2xl overflow-hidden max-w-md w-full shadow-xl relative border border-zinc-800">

                {/* Жабу батырмасы */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-zinc-300 hover:text-white hover:bg-white/10 transition p-2 rounded-full"
                >
                    ✕
                </button>

                {/* Үстіңгі блок (gradient + сурет) */}
                <div className="bg-gradient-to-b from-orange-400 via-orange-600 to-zinc-900 rounded-t-2xl p-4 text-white">
                    <img
                        src={bookData.imageUrl}
                        alt={bookData.name}
                        className="w-full h-[35vh] object-contain rounded-lg bg-white/10 mb-4"
                    />
                    <h2 className="text-2xl font-bold">{bookData.title}</h2>
                    <p className="text-md font-medium text-orange-100 mt-1">Құны: {bookData.price} ₸</p>
                </div>

                {/* Төменгі блок */}
                <div className="px-5 pt-4 pb-6 bg-zinc-900 text-sm text-zinc-200 space-y-3 max-h-[40vh] overflow-y-auto">
                    <p><span className="text-zinc-400">Сипаттама:</span> {bookData.description}</p>
                    <p><span className="text-zinc-400">Дыбыстаушы:</span> {bookData.sound}</p>

                    {bookData.demo && (
                        <audio controls className="w-full mt-2 rounded overflow-hidden">
                            <source src={bookData.demo} type="audio/mpeg" />
                            Сіздің браузеріңіз аудио ойнатуды қолдамайды.
                        </audio>
                    )}

                    <form onSubmit={handleBuyByCard}>
                        <p className="text-xs text-zinc-400 leading-snug">
                            Сатып алу арқылы сіз біздің{" "}
                            <a
                                href="https://esti.kz/esti_terms.pdf"
                                target="_blank"
                                className="underline hover:text-white"
                                rel="noreferrer"
                            >
                                төлем
                            </a>{" "}
                            және{" "}
                            <a
                                href="https://esti.kz/esti_policy.pdf"
                                target="_blank"
                                className="underline hover:text-white"
                                rel="noreferrer"
                            >
                                құпиялылық
                            </a>{" "}
                            шарттарымен келісесіз.
                        </p>

                        <button
                            type="submit"
                            className="mt-4 w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-full transition"
                        >
                            Сатып алу
                        </button>
                    </form>
                </div>
            </div>

            {/* Төлем модалы */}
            {isPaymentModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/70 backdrop-blur-sm z-[110]">
                    <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto relative">
                        <button
                            onClick={() => setIsPaymentModalOpen(false)}
                            className="absolute top-4 right-4 text-gray-700 hover:text-black bg-gray-200 hover:bg-gray-300 rounded-full p-2"
                        >
                            ✕
                        </button>
                        <div dangerouslySetInnerHTML={{ __html: paymentResponse }} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default BuyModal;